export { getConsentGroups, hasPerformanceConsent, hasTargetingConsent, type ConsentGroups } from './onetrust';

export {
	parseConsentGroupsFromCookie,
	hasPerformanceConsentFromCookie,
	hasTargetingConsentFromCookie,
} from './onetrust-cookie';
